<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import EChart from './EChart.vue'
import { categoryAxis, chartBase, chartTheme, valueAxis } from './chart-theme.js'
import { useAdminTheme } from '../composables/useAdminTheme.js'

const props = defineProps({
  items: { type: Array, required: true },
})

const { t } = useI18n()
const { theme: themeName } = useAdminTheme()

const option = computed(() => {
  const theme = chartTheme(themeName.value)
  const activePlayers = t('visualGameAdmin.analytics.metrics.activePlayers')
  const interactions = t('visualGameAdmin.analytics.metrics.interactions')
  return {
    ...chartBase(theme),
    color: [theme.bar, theme.info],
    grid: { top: 56, left: 16, right: 16, bottom: 12, containLabel: true },
    legend: {
      top: 8,
      textStyle: { color: theme.textMuted },
      data: [activePlayers, interactions],
    },
    tooltip: {
      ...chartBase(theme).tooltip,
      axisPointer: { type: 'line', lineStyle: { color: theme.border } },
      valueFormatter: (value) => Number(value).toLocaleString(),
    },
    xAxis: {
      ...categoryAxis(theme),
      boundaryGap: false,
      data: props.items.map(item => item.date),
      axisLabel: { color: theme.textMuted, hideOverlap: true, formatter: value => value.slice(5) },
    },
    yAxis: [
      {
        ...valueAxis(theme),
        name: activePlayers,
        minInterval: 1,
        nameTextStyle: { color: theme.textMuted },
      },
      {
        ...valueAxis(theme),
        name: interactions,
        minInterval: 1,
        nameTextStyle: { color: theme.textMuted },
      },
    ],
    series: [
      {
        name: activePlayers,
        type: 'line',
        yAxisIndex: 0,
        symbol: 'circle',
        symbolSize: 6,
        lineStyle: { width: 2 },
        data: props.items.map(item => item.active_players),
      },
      {
        name: interactions,
        type: 'line',
        yAxisIndex: 1,
        symbol: 'circle',
        symbolSize: 6,
        lineStyle: { width: 2 },
        data: props.items.map(item => item.interactions),
      },
    ],
  }
})
</script>

<template>
  <EChart :option="option" height="340px" />
</template>
